import { useState } from "react";
import { CoalescedPod } from "../../../api/pods.types";
import PodHistoryDialog from "../dialogs/PodHistoryDialog";

const usePodHistoryDialog = (pod: CoalescedPod | undefined): [JSX.Element, Function, Function] => {
  const [visible, setVisible] = useState(false);
  const [providerId, setProviderId] = useState<string>();

  const showDialog = (providerId: string): void => {
    setProviderId(providerId);
    setVisible(true);
  };

  const hideDialog = () => {
    setVisible(false);
  };

  const dialogComponent = (
    <PodHistoryDialog
      show={visible}
      pod={pod}
      providerId={providerId}
      onDismiss={hideDialog}
    />
  );

  return [
    dialogComponent,
    showDialog,
    hideDialog
  ];
};

export default usePodHistoryDialog;